import { motion } from "framer-motion";
import { SITE } from "../data/site";
import { WhatsAppIcon } from "./Header";

const WhatsAppFloat = () => (
    <motion.a
        href={SITE.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with OM Infra on WhatsApp"
        data-testid="whatsapp-float"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1.2, type: "spring" }}
        className="fixed bottom-[76px] right-4 md:bottom-5 md:right-5 z-[90] w-14 h-14 rounded-full bg-[#25D366] shadow-2xl flex items-center justify-center hover:brightness-95 transition-all"
    >
        <WhatsAppIcon className="w-7 h-7 text-white" />
    </motion.a>
);

export default WhatsAppFloat;
